<template>
    <div>  
        <div class="text-left">
            <h3 class="mb-3">{{$t('cal_marg_title')}}</h3>
            <p>{{$t('cal_marg_title_txt')}}</p>
        </div>
        <div class="verticallyTab mt-5">
			<p v-if="message != ''" style="color:red">{{message}}</p>
            <div class="bottomTab">
                <div class="stepForm-contact mt-5">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="segm" @change="currencyList()" v-validate="'required'" name="segm" :class="{ 'is-invalid': submitted && errors.has('segm'), 'active' : segm != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                    <!-- <option value=""></option> -->
                                    <option value="Forex">{{$t('cal_marg_forex')}}</option>
                                    <option value="Commodities">{{$t('cal_marg_commodities')}}</option>
                                    <option value="INDICIES">{{$t('cal_marg_indices')}}</option>
                                    <!--<option>Crypto</option>-->
                                </select>
                                <label class="float-label">Asset Class</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('segm')">{{$t('cal_marg_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="basecurreny" v-validate="'required'" name="basecurreny" :class="{ 'is-invalid': submitted && errors.has('basecurreny'), 'active' : basecurreny != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                    <!-- <option value=""></option> -->
                                    <option value="USD">{{$t('cal_comm_USD')}}</option>
                                    <option value="GBP">{{$t('cal_comm_GBP')}}</option>
                                    <option value="AUD">{{$t('cal_comm_AUD')}}</option>
                                    <option value="EUR">{{$t('cal_comm_EUR')}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_marg_accBaseCurr')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('basecurreny')">{{$t('cal_marg_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="selectedSymbol" v-validate="'required'" name="selectedSymbol" :class="{ 'is-invalid': submitted && errors.has('selectedSymbol'), 'active' : selectedSymbol != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                    <!-- <option value=""></option> -->
                                   <option v-for="spreads in isins" :value="spreads">{{spreads}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_marg_Symbol')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('selectedSymbol')">{{$t('cal_marg_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="leverage" v-validate="'required'" name="leverage" :class="{ 'is-invalid': submitted && errors.has('leverage'), 'active' : leverage != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                    <!-- <option value=""></option> -->
                                   <option v-for="list in leverageList" :value="list.val">{{list.name}}</option>
                                </select>
                                <label class="float-label">Leverage</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('leverage')">field is required</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <input type="text" v-model="tradesize" class="float-field form-control" v-validate="{ required: true,decimal:5}" name="tradesize" :class="{ 'is-invalid': submitted && errors.has('tradesize') }">
                                <label class="float-label" style="text-transform: none !important;">{{$t('cal_marg_trade_size_lot')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('tradesize')">{{$t('cal_marg_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper">
                                <a href="#" class="common_btn" v-on:click.prevent="calculateMargin()">{{$t('cal_marg_now')}}</a>
                                <div class="table-responsive"> 
                                    <table class="table commodities-table fundingMethodstable table-bordered table-striped  my-5">
                                        <!-- <thead>
                                            <tr>
                                                <th>&nbsp;</th>
                                                <th>Global-Retail: CySEC-Retail</th>
                                                
                                            </tr>
                                        </thead> -->
                                        <tbody>
                                            <tr>
                                                <td>{{$t('cal_marg_req')}}</td>
                                                <td>{{basecurreny}} {{commsionCYR.toFixed(2)}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{$t('cal_marg_max_lev')}}</td>
                                                <td>{{commsionCYRLev}}x</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'Margin',
        mixins: [fxViewMixins],
        data() {
            return {
                "isins":'',
                "segm": 'Forex',
                "tradesize": 0,
                "selectedSymbol":"",
                "selectedSeg":"",
                "commission": 0,
                "basecurreny":'USD',
                "commsionCYR":0,
                "commsionCYRLev":"-",
                "commsionCYPRF": 0,
                "commsionCYPRFLev": "-",
				submitted : false,
				message : '',
                providedDynamicLeverage:'',
                leverage:100,
                leverageList:[
                    {val:'100',name:'100'},
                    {val:'200',name:'200'},
                    {val:'300',name:'300'},
                    {val:'400',name:'400'},
                    {val:'500',name:'500'},
                ],
                allIsins:''
            }
        },
        methods:{
            currencyList(){
                this.isinList=""
                this.providedDynamicLeverage= this.$env_var.dynamic_leverage;
                this.allIsins = this.$store.getters['/GET_ISINS_LIST'];
                this.isins = Object.keys(this.allIsins).filter(key => this.allIsins[key].type === this.segm);
                return this.isins;
            },
            getSymbol(getSymbolFor){
                if(getSymbolFor == 'commd'){
                    this.isins = Object.keys(this.get_Commodity_All)
                }if(getSymbolFor == 'forex'){
                    this.isins = Object.keys(this.get_currencies)
                }if(getSymbolFor == 'indic'){
                    this.isins = Object.keys(this.get_Indices_all)
                }

                this.selectedSeg = getSymbolFor

                // this.isins = getData
            },
            calculateMargin(){
				const _that = this
                this.submitted = true;
				this.message = ''
                this.$validator.validate().then(valid => {
                    if (valid) {
						let calculation = ''
                        let secondaryCurrencyPrice=""
                        let leverageProvided= this.leverage
                        let selectedCurrecy= this.allIsins[_that.selectedSymbol]
                        let firstCurrency=''
                        let priceFeed= this.$store.getters['/GET_PRICEFEED_DATA'];
                        
                        let fetchedSelectedSymbol= ''
                        const match = _that.selectedSymbol.match(/\((.*?)\)/); // Regex to find text within brackets
                        if (match) {
                            fetchedSelectedSymbol = match[0]; // Get the content inside the brackets
                        }else {
                            fetchedSelectedSymbol = _that.selectedSymbol; // No brackets found
                        }                       
                        let selectedIsinPrice= priceFeed[fetchedSelectedSymbol]
                        calculation = (selectedIsinPrice.A*(_that.tradesize*selectedCurrecy.Contract_Size))/leverageProvided
                        this.commsionCYRLev= selectedIsinPrice.other.levRT
                        if(_that.segm=='Shares'){
                            firstCurrency="USD"
                        }else{
                            if(_that.selectedSymbol.includes('.') || _that.selectedSymbol.includes('(')){
                                if(_that.selectedSymbol.includes('.')){
                                    let lastSymbol=_that.selectedSymbol.trim('.')
                                    firstCurrency = lastSymbol.slice('3','6')
                                }else if(_that.selectedSymbol.includes('(')){
                                    let lastSymbol=_that.selectedSymbol.split('(')[0]
                                    firstCurrency = lastSymbol.slice('3','6')
                                }
                            }else if(_that.selectedSymbol.includes('-')){
                                let lastSymbol=_that.selectedSymbol.replace('-', '')
                                firstCurrency = lastSymbol.slice('3','6')
                            }else{                            
                                firstCurrency = _that.selectedSymbol.slice('3','6')
                            }
                        }
                        if(firstCurrency == _that.basecurreny){
                            secondaryCurrencyPrice = 1
                            this.commsionCYR= calculation/secondaryCurrencyPrice
                        }else{
                            let secondaryCurrencyPrice = priceFeed[firstCurrency+_that.basecurreny]
                            if(secondaryCurrencyPrice){
                                this.commsionCYR = secondaryCurrencyPrice.A*calculation
                            }else if(priceFeed[_that.basecurreny+firstCurrency]){
                                secondaryCurrencyPrice = priceFeed[_that.basecurreny+firstCurrency]
                                this.commsionCYR = (1/secondaryCurrencyPrice.A)*calculation
                            }else{                        
                                let allIsinList = []
                                let filteredIsins=[]
                                let secondPrice=''
                                allIsinList= Object.keys(this.allIsins)
                                filteredIsins = allIsinList.filter(val=>val.includes(firstCurrency)&&val.includes("USD"))
                                let filteredIsinsSecond=[]
                                filteredIsinsSecond = allIsinList.filter(val=>val.includes(_that.basecurreny))
                                let filteredIsinsSecondPrice= priceFeed[filteredIsinsSecond[0]]
                                secondPrice= 1/filteredIsinsSecondPrice.A
                                filteredIsins.forEach(val=>{
                                    if(val.slice(0,3)=='USD'){
                                    let price= priceFeed['USD'+firstCurrency]
                                    this.commsionCYR= (price.A*secondPrice)*calculation
                                    }else if(val.slice(3,6)){
                                    let price= priceFeed[firstCurrency+'USD']
                                    this.commsionCYR= (price.A*secondPrice)*calculation
                                    }
                                })
                            }
                        }	
					}
				})
            }
        },
        computed:{
            fetchedIsins(){
                let isinData= this.$store.getters['/GET_ISINS_LIST'];                 
				return isinData;
			}
        },
        mounted() {
            this.currencyList()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/shared/calculators/margin.vue